export default __webpack_public_path__ + "static/media/BEHAbelt.57c2130d.png";